import { observable, action, computed, makeObservable } from 'mobx';
import _ from 'lodash';
import apiActions from 'api/actions';

export class LessonProgressLog {
  constructor(data, root) {
    this._root = root;
    this.id = data.id;
    this.feels_mastered = data.feels_mastered;
    this.admin = data.admin;
    this.comment = data.comment;
    this.student_id = data.student_id;
    this.instructor_id = data.instructor_id;
    this.lesson_id = data.lesson_id;
    this.inserted_at = data.inserted_at;
  }

  get instructor() {
    return this.instructor_id ? this._root.UserStore.find(this.instructor_id) : null;
  }

  get lesson() {
    return this._root.TopicStore.findLesson(this.lesson_id);
  }

  get skill() {
    return this.lesson.skill;
  }
}

export default class LessonProgressLogStore {
  constructor(root) {
    makeObservable(this, {
      data: observable,
      requests: observable,
      add: action,
      addMany: action,
      remove: action,
      all: computed,
      reset: action,
      fetchForStudent: action,
      refetch: action,
    })

    this.root = root;
  }

  data = new Map();
  requests = new Map();

  add = data => {
    const log = new LessonProgressLog(data, this.root);
    this.data.set(log.id, log);
  }

  addMany = datas => {
    const merge = new Map();
    datas.forEach(data => {
      const log = new LessonProgressLog(data, this.root);
      merge.set(log.id, log);
    });
    this.data.merge(merge)
  }

  remove = id => {
    if (id && this.data.has(id)) this.data.delete(id);
  }

  find(id) {
    return this.data.get(id);
  }

  get all() {
    return Array.from(this.data.values());
  }

  allForStudent(studentId) {
    return _.filter(this.all, ['student_id', studentId]);
  }

  latestForStudent(studentId) {
    return _.chain(this.allForStudent(studentId))
            .sortBy('inserted_at')
            .last()
            .value();
  }

  allForStudentAndLesson(studentId, lessonId) {
    return _.filter(this.allForStudent(studentId), ['lesson_id', lessonId]);
  }

  reset = () => {
    this.data.clear();
    this.requests.clear();
  }

  fetchForStudent(studentId) {
    if (this.requests.get(studentId) === undefined) {
      this.requests.set(studentId, 'pending');
      return apiActions.rawGet(`users/${studentId}/lesson_progress_logs`).then(response => {
        this.addMany(response.data);
        this.requests.set(studentId, 'complete')
      })
    }
  }

  refetch() {
    const fetched = this.requests.keys();
    if (fetched.length > 0) {
      this.reset();
      const fetchPromises = fetched.map(this.fetchForStudent)
      return Promise.all(fetchPromises);
    }
    return Promise.resolve();
  }

  fetchForStudentCompleted(studentId) {
    return this.requests.get(studentId) === 'complete';
  }
}
